import SelectController from "confinus_ui/forms/select_controller";
import BaseController from "confinus_ui/base_controller";
import { markAsSafeHTML } from "lib/util/safe_html";
import { Category } from "lib/types";
import { ConfinusUI__Forms__SelectControllerIdentifier } from "controllers/identifiers";

export default class ProductCategoryFilterTierController extends BaseController {
  public static values = {
    categories: Array,
  };

  declare public categoriesValue: Category[];
  public static outlets = [ConfinusUI__Forms__SelectControllerIdentifier];
  declare private readonly confinusUiFormsSelectOutlet: SelectController;

  public onInitialize() {
    return super.onInitialize();
  }

  public set disabled(disabled: boolean) {
    if (disabled) {
      this.confinusUiFormsSelectOutlet.empty("Category");
    }

    this.confinusUiFormsSelectOutlet.disabled = disabled;
  }

  public set options(newOptions: Category[]) {
    this.categoriesValue = newOptions;

    if (newOptions.length === 0) {
      this.disabled = true;
      return;
    }

    this.confinusUiFormsSelectOutlet.empty("Category");
    const newHtml = newOptions
      .map((category) => `<option value='${category.i}'>${category.n}</option>`)
      .reduce((previous, current) => (previous += current));

    this.confinusUiFormsSelectOutlet.options = markAsSafeHTML(
      this.confinusUiFormsSelectOutlet.optionsHTML + newHtml,
    );
    this.disabled = false;
  }

  public get value(): string {
    return this.confinusUiFormsSelectOutlet.value;
  }
}
